package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FormatBoldW500Rounded: ImageVector
    get() {
        if (_formatBoldW500Rounded != null) {
            return _formatBoldW500Rounded!!
        }
        _formatBoldW500Rounded = Builder(name = "FormatBoldW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(351.04f, 767.89f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-394.02f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(149.61f)
                quadToRelative(68.11f, 0.0f, 123.71f, 42.03f)
                quadToRelative(55.6f, 42.03f, 55.6f, 113.99f)
                quadToRelative(0.0f, 48.13f, -21.81f, 77.43f)
                quadToRelative(-21.8f, 29.29f, -45.39f, 42.48f)
                verticalLineToRelative(0.72f)
                quadToRelative(29.54f, 12.68f, 58.37f, 45.07f)
                reflectiveQuadToRelative(28.83f, 89.52f)
                quadToRelative(0.0f, 86.61f, -64.29f, 125.69f)
                quadToRelative(-64.28f, 39.09f, -127.5f, 39.09f)
                lineTo(351.04f, 767.89f)
                close()
                moveTo(389.17f, 651.59f)
                horizontalLineToRelative(109.98f)
                quadToRelative(43.22f, 0.0f, 56.11f, -22.95f)
                quadToRelative(12.89f, -22.94f, 12.89f, -37.77f)
                quadToRelative(0.0f, -14.83f, -12.89f, -37.89f)
                quadToRelative(-12.89f, -23.07f, -58.39f, -23.07f)
                horizontalLineToRelative(-107.7f)
                verticalLineToRelative(121.68f)
                close()
                moveTo(389.17f, 417.37f)
                horizontalLineToRelative(99.46f)
                quadToRelative(31.09f, 0.0f, 46.92f, -16.88f)
                quadToRelative(15.84f, -16.88f, 15.84f, -38.6f)
                quadToRelative(0.0f, -24.0f, -17.36f, -39.36f)
                reflectiveQuadToRelative(-43.88f, -15.36f)
                lineTo(389.17f, 307.17f)
                verticalLineToRelative(110.2f)
                close()
            }
        }
        .build()
        return _formatBoldW500Rounded!!
    }

private var _formatBoldW500Rounded: ImageVector? = null
